<template>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'系统配置'},{name:'前端配置'}]" :title="'前端配置'"/> -->
            <!-- 主内容 -->
            <div class="box">
                <ul class="leftBox">
                    <li 
					:class="tab==index?'active':''" 
					@click="changeTab(index,i)"
					v-for="(i,index) in volist"
					:key="index"
					
					>
					{{i.permissionName}}
					</li>
                    <!-- <li :class="tab==2?'active':''" @click="changeTab(2)">基金合作-合作机构</li>
                    <li :class="tab==3?'active':''" @click="changeTab(3)">担保服务-附件</li>
                    <li :class="tab==4?'active':''" @click="changeTab(4)">联系我们</li> -->
                </ul>
                <div class="rightBox">
                    <!-- 内容 -->
                    <router-view :iData="iData" :tab="tab"></router-view>
                </div>
            </div>
        </div>
</template>

<script>
import {mapState} from 'vuex'
// import breadcrumb from '../../../components/breadcrumb';
export default {
    components:{
        // breadcrumb
    },
    data(){
        return{
            tab:0,//选项卡,
			volist:[],
			firstPath:'',
			iData:[],
			isfirst:true,
        }
    },
	computed:{
		...mapState('left',{
		  leftList:state=>state.leftList,
		}),
	},
	created() {
		// if(this.isfirst){
		// 	this.tab=0;
		// }else{
			
		// }
    this.tab= localStorage.getItem('numTable')? parseInt(localStorage.getItem('numTable')) : 0
	},
  destroyed(){
      localStorage.removeItem('numTable')
  },
	mounted() {
		let leftList=this.leftList;
		for (let i in leftList) {
			if(leftList[i].permissionName=='系统配置'){
				let list=leftList[i].sysPermissionVoList;//前端配置
				for(let j in list){
					if(list[j].permissionName=='前端配置'){
						let volist=list[j].sysPermissionVoList;
						this.volist=volist;
						this.iData=volist[0].sysPermissionVoList;
						this.firstPath=volist[0].href;
					}
				}
			}
		}
	},
    methods:{
        //切换选项卡
        changeTab:function(num,i){
            this.tab=num;
			this.isfirst=false;
			localStorage.setItem('numTable',num)
			let iData=i;
			this.iData=i.sysPermissionVoList;
			this.$router.push(
				{
					path:iData.href,
					query:{
						index:this.firstPath,iData:iData.sysPermissionVoList,
					},
				}
			);
			
            // switch (num){
            //     case 1:
            //         this.$router.push({path:'/systemLayout/configuration/configurationFirst',query:{index:'/systemLayout/configuration/configurationFirst',iData:iData}});
            //         break;
            //     case 2:
            //         this.$router.push({path:'/systemLayout/configuration/configurationSecond',query:{index:'/systemLayout/configuration/configurationFirst',iData:iData}});
            //         break;
            //     case 3:
            //         this.$router.push({path:'/systemLayout/configuration/configurationThird',query:{index:'/systemLayout/configuration/configurationFirst',iData:iData}});
            //         break;
            //     case 4:
            //         this.$router.push({path:'/systemLayout/configuration/configurationFourth',query:{index:'/systemLayout/configuration/configurationFirst',iData:iData}});
            //         break;
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
	  overflow: hidden;
    height:calc(100% - 40px);
    .box{
        display: flex;
        height:100%;
        overflow: hidden;
        .leftBox{
            margin-right: 20px;
            li{
                width: 220px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                color: #595959;
                font-size: 14px;
                cursor: pointer;
                &:not(:last-child){
                    border-bottom: none;
                }
                &.active{
                    color: #1069DD;
                    background: #F2FBFF;
                }
            }
        }
        .rightBox{
            flex: 1;
            width:calc(100% - 240px);
        }
    }
}
</style>